import { render, staticRenderFns } from "./PrivateChatRightSidebar.vue?vue&type=template&id=39ebcb3c&scoped=true&"
import script from "./PrivateChatRightSidebar.vue?vue&type=script&lang=js&"
export * from "./PrivateChatRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PrivateChatRightSidebar.vue?vue&type=style&index=0&id=39ebcb3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ebcb3c",
  null
  
)

export default component.exports